import { render, staticRenderFns } from "./ReturnsExportButtons.vue?vue&type=template&id=45cb0532&"
import script from "./ReturnsExportButtons.vue?vue&type=script&lang=js&"
export * from "./ReturnsExportButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports